/**
 * @generated SignedSource<<58dac22249edf00979741a8a683c73ca>>
 * @relayHash 0fd4072175c8fe4b70be5b778b8275d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d99fca6262af9031d992216d6a26bb187ea304a8a6bd9a8187762df24a999afe

import type { ConcreteRequest, Query } from 'relay-runtime';
export type fetchNativeCollabAGGUsersQuery$variables = {
  accountIds: ReadonlyArray<string>;
};
export type fetchNativeCollabAGGUsersQuery$data = {
  readonly users: ReadonlyArray<{
    readonly accountId: string;
    readonly id: string;
    readonly name: string;
    readonly picture: AGG$URL;
  }> | null | undefined;
};
export type fetchNativeCollabAGGUsersQuery = {
  response: fetchNativeCollabAGGUsersQuery$data;
  variables: fetchNativeCollabAGGUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "picture"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "fetchNativeCollabAGGUsersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchNativeCollabAGGUsersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0fd4072175c8fe4b70be5b778b8275d1",
    "id": "d99fca6262af9031d992216d6a26bb187ea304a8a6bd9a8187762df24a999afe",
    "metadata": {},
    "name": "fetchNativeCollabAGGUsersQuery",
    "operationKind": "query",
    "text": "query fetchNativeCollabAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){__typename,accountId,name,picture,id}}"
  }
};
})();

(node as any).hash = "06df0642dffe62239e8db6cdf41fa76d";

export default node;
